<template>
  <div>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        noDataText="Nenhum Fluxo Encontrado"
        class="tablePrincipal"
        ref="table"
        pagination
        :max-items="itemsPerPage"
        :data="itens"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div>
            <vs-button
              v-if="$can($actionsDefault.Escrita, subjectPermission)"
              @click="openModal"
              color="primary"
              icon="add_circle_outline"
              class="h-12 mr-4 flex items-center justify-center px-4"
            >
              Cadastrar
            </vs-button>
          </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">{{ paginationText }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <template slot="thead">
          <vs-th style="width: 20%">Nome</vs-th>
          <vs-th style="width: 20%">Executar em</vs-th>
          <vs-th style="width: 20%">Path</vs-th>
          <vs-th style="width: 20%">Ativo</vs-th>
          <vs-th style="width: 20%">Ações</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr v-for="workflow in data" :key="workflow.id">
              <vs-td class="nowrap">
                <p>{{ workflow.flowName }}</p>
              </vs-td>
              <vs-td>
                <vs-chip color="primary" class="font-bold">
                  {{ getExecutionLabel(workflow.executionStageCode) }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p>{{ workflow.path }}</p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="workflow.isActive ? 'success' : 'danger'"
                  class="font-bold"
                >
                  {{ workflow.isActive ? 'Ativo' : 'Inativo' }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div class="vx-row">
                  <div
                    class="vx-col"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  >
                    <vs-button
                      radius
                      v-tooltip="'Histórico de Alterações'"
                      color="#88abc2"
                      icon-pack="feather"
                      icon="icon-archive"
                      class="d-inline"
                      @click="openHistoryModal(workflow.id)"
                    ></vs-button>
                    <vs-button
                      v-tooltip="'Editar fluxo'"
                      radius
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="d-inline ml-2"
                      @click="editWorkflow(workflow)"
                    ></vs-button>
                    <vs-button
                      v-tooltip="'Excluir fluxo'"
                      radius
                      color="danger"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-trash"
                      class="d-inline ml-2"
                      @click="confirmDelete(workflow)"
                    ></vs-button>
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <WorkflowModal
      :isOpen.sync="isModalOpen"
      :workflow="selectedWorkflow"
      :executionStages="executionStages"
      @close="closeModal"
      @save="handleSave"
    />

    <WorkflowHistoryModal
      :isOpen.sync="isHistoryModalOpen"
      :workflowId="selectedWorkflowId"
      @close="isHistoryModalOpen = false"
    />

    <Modal
      :active.sync="isDeleteModalOpen"
      title="Confirmação de Exclusão"
      class="workflow-modal"
      @close="isDeleteModalOpen = false"
    >
      <div>
        <p>
          Tem certeza que deseja excluir o workflow
          <strong>{{ workflowToDelete && workflowToDelete.flowName }}</strong
          >?
        </p>
      </div>
      <div class="form-actions">
        <vs-button @click="deleteWorkflow" color="danger" block>
          Excluir
        </vs-button>
        <vs-button
          @click="isDeleteModalOpen = false"
          color="dark"
          outline
          block
        >
          Cancelar
        </vs-button>
      </div>
    </Modal>
  </div>
</template>

<script>
import n8n from '../../../../../services/n8n';
import WorkflowModal from './WorkflowModal.vue';
import {
  EXECUTION_STAGES,
  getExecutionStageLabel,
} from '../../../../../constants/executionStages';
import Modal from '../../../../../components/Modal.vue';
import WorkflowHistoryModal from './WorkflowHistoryModal.vue';

export default {
  name: 'WorkflowList',
  props: ['subjectPermission'],
  components: { WorkflowHistoryModal, Modal, WorkflowModal },
  data() {
    return {
      isModalOpen: false,
      isDeleteModalOpen: false,
      workflowToDelete: null,
      itens: [],
      itemsPerPage: 50,
      currentPage: 1,
      selectedWorkflow: null,
      executionStages: EXECUTION_STAGES,
      isHistoryModalOpen: false,
      selectedWorkflowId: null,
    };
  },
  computed: {
    paginationText() {
      const start =
        this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
      const end =
        this.itens.length - this.currentPage * this.itemsPerPage > 0
          ? this.currentPage * this.itemsPerPage
          : this.itens.length;

      return `${start} - ${end} de ${this.itens.length}`;
    },
  },
  mounted() {
    this.getWorkflows();
  },
  methods: {
    async getWorkflows() {
      this.itens = await n8n.getWorkflows();
    },

    openHistoryModal(workflowId) {
      this.selectedWorkflowId = workflowId;
      this.isHistoryModalOpen = true;
    },

    handleSave() {
      this.getWorkflows();
      this.closeModal();
    },

    editWorkflow(workflow) {
      this.selectedWorkflow = { ...workflow };
      this.isModalOpen = true;
    },

    openModal(workflow = null) {
      this.selectedWorkflow = workflow;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },

    getExecutionLabel(stageCode) {
      return getExecutionStageLabel(stageCode);
    },

    confirmDelete(workflow) {
      this.workflowToDelete = workflow;
      this.isDeleteModalOpen = true;
    },

    async deleteWorkflow() {
      try {
        await n8n.deleteWorkflow(this.workflowToDelete.id);
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: `Workflow ${this.workflowToDelete.flowName} foi excluído com sucesso.`,
          color: 'success',
        });

        await this.getWorkflows();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Erro ao excluir workflow. Tente novamente.',
          color: 'danger',
        });
      } finally {
        this.isDeleteModalOpen = false;
        this.workflowToDelete = null;
      }
    },
  },
};
</script>

<style>
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
      .error-border {
        border: 2px solid orange;
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .vs-button.includeIcon {
    float: left;
    margin-right: 5px;
  }
}
</style>
